<template>

  <div class="atividades-sacsolicitacoes ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->

              <b-col cols="3">
                <label for="select-empresa">Empresa</label> 
                <multiselect  id="selecao-empresa-sol"  v-model="value_empresa" required                  
                  :options="empresas" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false" 
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="empresa" track-by="empresa" name="empresa"
                  :preselect-first="true">                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="2">
                <label for="select-garagem_sol">Filial</label> 
                <multiselect id="selecao-filial-sol"  v-model="value_filial" required                   
                  :options="filiais" 
                  :multiple="true" 
                   :taggable="true"                   
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  @close="loadTipoFolha()"
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>


              <b-col cols="2">
                   <label for="select-status">Tipo de recibo</label>  

                <multiselect id="selecao-status-sol" v-model="value_status"  required  
                :options="statuss" 
                :multiple="true"         
                :taggable="true"  
                @close="loadTipoFolha()"  
                @tag="addTag"                           
                :close-on-select="false" 
                :clear-on-select="false" 
                :preserve-search="true" placeholder="Status" label="status" track-by="status" name="status"
                :preselect-first="true">                 
                <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} status selecionado</span></template>
                </multiselect>                
              </b-col> 

                            <!-- condicional para exibir o botão planilha-->
              <b-col cols="1" class="mt-4 mr-5">
                <br>                 
                 <input type="file" @change="handleFileUpload" />
                
              </b-col>


                            <b-col cols="1"  class="ml-5">
                <br>                 
                <b-button  variant="primary" class="mr-2 mt-2" block  @click="carregando = true,postRecibos()">
                   Gravar
                </b-button>                      
              </b-col>
              <b-col cols=""  class="mb-0 ">
                <label  for="input-busca">Pesquisa no grid  </label> 
                <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Registro ou Tipo de solicitação ou palavras na solicitação"></b-form-input>              
              </b-col>   




              <LoadingModal v-if="isLoadingRecibos" />   


          </b-row>
    </b-form>




      <b-row>

            <b-col cols=3 class="mt-3">

              <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="QUANTIDADE DE FUNCIONÁRIOS"
                header-bg-variant="danger"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                  {{ distinctCodCount  }}
                  </h2>
                </b-card-text>
              </b-card>
            </b-col>

            <b-col cols=3 class="mt-3">
            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="R$ TOTAL DE PROVENTOS"
              header-bg-variant="warning"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ sumProventos }}
                </h2>
                
                
              </b-card-text>
            </b-card>
            </b-col>

          <b-col cols=3 class="mt-3">
            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="R$ TOTAL DE DESCONTOS"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ sumDescontos ? sumDescontos : 0 }}
                </h2>
                
              </b-card-text>
      </b-card>        
      </b-col>
      
      <b-col cols=3 class="mt-3">
          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="R$ TOTAL DE LIQUIDO "
            header-bg-variant="primary"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{sumLiquido ? sumLiquido : 0}}
              </h2>
              
            </b-card-text>
          </b-card>
        </b-col>

      </b-row>


    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>         

    
<b-progress max="100" :value="progressValue">
  <template v-slot:label>{{ progressValue.toFixed(2) }}%</template>
</b-progress>


    <!--tbl de dados -->
    <b-table id="resolicitante"  small hover striped sticky-header="756px"  :items="itemsFiltered" :fields="fieldsRecibos" >    

    </b-table>
      
      <!--  MODAL SOLICITÇÕES  -->
      <div>        
    <b-modal id="modal-multi-1" cancel-title="Fechar" ok-title="Gravar" @ok="postSac()"  size="xl" :title="`Solicitação Nº.: ${sacsolicitacao.id_solicitacao != null ? sacsolicitacao.id_solicitacao :'-' }`"     no-close-on-esc no-close-on-backdrop>
          <!-- -->
          <div>

            <b-row>
              <input  id="id-sac" type="hidden" v-model="sacsolicitacao.id_solicitacao" />

              <b-col cols="1" class="mt-2  pr-4" >
                  <b-form-group label="" label-for="tabela-foto">
                    <b-img                         height="120" width="78" 
                        class="mb-5" 
                        v-model="sacsolicitacao.foto_url"                         
                        v-bind="mainProps" rounded alt="Foto"
                        
                        :src="sacsolicitacao.foto_url"
                    >
                    </b-img>
                  </b-form-group>                  
              </b-col>
              
              <b-col cols="2" class="mt-5">
                <label for="input-live">Registro</label> 
                <b-form-input  id="resolicitante" v-model="sacsolicitacao.re_solicitante" readonly placeholder="" class="mb-3"></b-form-input>
              </b-col>

              <b-col cols="3" class="mt-5">
                <label for="input-live">Nome</label> 
                <b-form-input  id="resolicitante" v-model="sacsolicitacao.nome" readonly placeholder="" class="mb-3"></b-form-input>
              </b-col>

              <b-col cols="3" class="mt-5">
                <label for="input-live">Função</label>
                <b-form-input id="resolicitante" v-model="sacsolicitacao.funcao_solicitante" readonly placeholder=""></b-form-input>              
              </b-col>

            <b-col sm="3" class="mt-5">
              <label for="input-resolicitante">Parecer</label> 
              <div>                    
                <b-form-select   id="resolicitante"               
                  v-model="sacsolicitacao.id_status"  
                  :options="statuss"
                  class="mb-3"
                  text-field="status"                            
                >                
                </b-form-select>
              </div>
            </b-col> 

            </b-row> 

            <b-row>
              <b-col sm="3">
                <label for="textarea-small">Justificativa</label>  
              </b-col>
              <b-col sm="12">
                <b-form-textarea
                  id="id-pecas" 
                  v-model="sacsolicitacao.justificativa" 
                  readonly            
                  size="sm"
                  class="mb-3"
                  placeholder="Pergunta do colaborador"
                ></b-form-textarea>
              </b-col>
            </b-row> 

            <!-- Tratativas -->                
          <div class="d-flex justify-content-center mb-3">
            <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
          </div>    
          <!--tbl de dados -->



            <b-row>
              <b-col sm="12">
                
                <label for="textarea-small">Parecer da solicitação:</label>  

            
                
              </b-col>
              <b-col sm="12">
                <b-form-textarea                   
                  id="id-obs"
                  v-model="sacsolicitacao.parecer"
                  size="sm"      
                  placeholder="Digite o parecer para o colaborador"
                  
                ></b-form-textarea>
              </b-col>
            </b-row>

            <b-row>
              <b-col class="mb-3 mt-3 ml-5" >
                <div>
                  <b-img v-if="sacsolicitacao.file==='true'" :src="sacsolicitacao.file"  width="600" height="600"></b-img>
                </div>                              
              </b-col>
            </b-row>             
          </div>
          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment, { now } from 'moment'
import { mapState } from 'vuex' 
import * as XLSX from 'xlsx'
//import LoadingModal_atendimento from '../utilitarios/LoadingModal'



export default {    
    name: 'SacSolicitacao',    

    
    computed : { ... mapState (['user'],),
    
itemsFiltered() {
  let valores = [];
  
  valores = this.planilhaDadosRecibos.filter((item) => {
    // Verifica se item.COD existe e é uma string
    const cod = item.COD ? String(item.COD) : ''; // Se COD for undefined ou null, converte para string vazia

    // Verifica se a string COD contém o texto de busca
    return cod.indexOf(this.search) > -1;
  });

  return valores;
},

    distinctCodCount() {
      // Cria um Set para garantir que estamos contando valores únicos de COD
      const distinctItems = new Set(this.itemsFiltered.map(item => item.COD));
      
      // Retorna o número de valores distintos de COD
      return distinctItems.size;
    },


   sumProventos() {
  // Soma os valores de DESCONTO somente quando EVE for igual a 302, 304 ou 318
  const totalProventos = this.itemsFiltered.reduce((sum, item) => {
    // Verifica se o item possui um EVE válido e se o EVE é um dos valores especificados
    if (['TOTAL PROVENTOS '].includes(item.DENOMINACAO)) {
      const provento = parseFloat(item.PROVENTO);
      
      // Se o valor de desconto for válido, adiciona ao total
      return sum + (isNaN(provento) ? 0 : provento);
    }
    return sum;
  }, 0);
  
  // Divide o total de descontos por 10
  const result = totalProventos;

  // Retorna o valor formatado no padrão pt-BR com moeda brasileira
  return result.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
},



    sumDescontos() {
  // Soma os valores de DESCONTO somente quando EVE for igual a 302, 304 ou 318
  const totalDescontos = this.itemsFiltered.reduce((sum, item) => {
    // Verifica se o item possui um EVE válido e se o EVE é um dos valores especificados
    if (['TOTAL DESCONTO'].includes(item.DENOMINACAO)) {
      const desconto = parseFloat(item.DESCONTO);
      
      // Se o valor de desconto for válido, adiciona ao total
      return sum + (isNaN(desconto) ? 0 : desconto);
    }
    return sum;
  }, 0);
  
  // Divide o total de descontos por 10
  const result = totalDescontos;

  // Retorna o valor formatado no padrão pt-BR com moeda brasileira
  return result.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
},

    sumLiquido() {
  // Soma os valores de DESCONTO somente quando EVE for igual a 302, 304 ou 318
  const totalLiquido = this.itemsFiltered.reduce((sum, item) => {
    // Verifica se o item possui um EVE válido e se o EVE é um dos valores especificados
    if ([302].includes(item.EV)) {
      const liquido = parseFloat(item.PROVENTO);
      
      // Se o valor de desconto for válido, adiciona ao total
      return sum + (isNaN(liquido) ? 0 : liquido);
    }
    return sum;
  }, 0);
  
  // Divide o total de descontos por 10
  const result = totalLiquido;

  // Retorna o valor formatado no padrão pt-BR com moeda brasileira
  return result.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}



        

   
    } ,

    data: function() {        
      
        return {

            planilhaDadosRecibos: [],
            isLoadingRecibos: false,  // Controle de carregamento
            progressValue: 0,  // Valor da barra de progresso
            mode: 'save',
            carregando: false,
            atualizando: false,               
            empresa:{}, 
            empresas:[],   // [] lista       
            value_empresa:[],// [this.empresas],            
            value_filial:[],            
            value_status:[],     
            filial:{}, 
            filiais: [],   // [] lista            
            //value_filial:[],// [] lista     
            
            status:{},
            statuss: [],   // [] lista            

            permissoes:[],
            permissao:{},
                                     
            sacsolicitacao:{},// [] lista              
            sacsolicitacoes:[],// [] lista
            pedidoferias:[],    // implantado 08/07/2023
            sacT:{},// [] lista  
            sacsolicitacoestratativa:[],// [] lista
            search:'',
       
            value_id_area:'',     
        
            fieldsRecibos: [
              
                { key: 'REF', label: 'Competência', sortable: true },     
                { key: 'EMP', label: 'Empresa', sortable: true },                 
                { key: 'COD', label: 'Registro', sortable: true },  
                { key: 'NOME DO FUNCIONARIO', label: 'Nome', sortable: true },  
                
                
                { key: 'FUNCAO', label: 'Função', sortable: true },  
                
                { key: 'HS BASE', label: 'Horas base', sortable: true },
                //{ key: 'DATA DO PAGAMENTO', label: 'Data de pagamento', sortable: true },                
                
                { key: 'EV', label: 'Código evento', sortable: true },                
                { key: 'DENOMINACAO', label: 'Evento', sortable: true },                
                { key: 'HORAS', label: 'Horas', sortable: true },                   
                            

{
  key: 'PROVENTO',
  label: 'Valor Provento',
  sortable: true,
  formatter: (value, key, planilhaDadosRecibos) => {
    const provento = planilhaDadosRecibos['PROVENTO'];
    return provento ? (provento).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-';
  },
}




,
                        
{
  key: 'DESCONTO',
  label: 'Valor Desconto',
  sortable: true,
  formatter: (value, key, planilhaDadosRecibos) => {
    const desconto = planilhaDadosRecibos['DESCONTO'];
    return desconto ? (desconto).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-';
  },
}
,
                
      

            ],
            //////// defeitos da corretiva




        }        
    },

    components: {
        Multiselect //,LoadingModal_atendimento
    },
    methods: {

handleFileUpload(event) {
  const file = event.target.files[0];
  const reader = new FileReader();


  // Define isLoading como true para mostrar o indicador de carregamento
  this.isLoadingRecibos = true;

  reader.onloadstart = () => {
    this.progressValue = 0; // Inicia a barra de progresso
  };

  reader.onprogress = (e) => {
    if (e.lengthComputable) {
      // Atualiza a barra de progresso
      this.progressValue = (e.loaded / e.total) * 100;
    }
  };

  reader.onload = (e) => {
    const data = e.target.result;
    const workbook = XLSX.read(data, { type: 'binary' });

    // Supondo que os dados estejam na primeira aba
    const sheet = workbook.Sheets[workbook.SheetNames[0]];

    // Converte a planilha em um array de objetos
    const jsonData = XLSX.utils.sheet_to_json(sheet);

    // Armazena os dados no estado
    this.planilhaDadosRecibos = jsonData;

    // Quando o processo for concluído, define isLoading como false
    this.isLoadingRecibos = false;
  };

  reader.readAsBinaryString(file);
}

,

      


              loadEmpresas() {
            let params = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/ctr/empresa`
          axios.post(url,{params}).then(res => {
            this.empresas = res.data.map(empresa => {              
              return { id_empresa: empresa.id_empresa, empresa: empresa.nomeempresarial }
            })
          })
        },  

                loadFiliais() {
            let params = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };
          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.post(url,{params}).then(res => {
            this.filiais = res.data.map(filial => {              
              return { id_filial_erp: filial.id_filial_erp, filial: filial.filial }        
            })
          })
        }, 



        loadTipoFolha() {
                      let params = {    
                "id_grupo": `${this.user.id_grupo}`,                                            
                "id_empresa": `${this.user.id_empresa}`,   
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                  
            };
          const url = `${baseApiUrl}/sac/status`
          axios.get(url,{params}).then(res => {
            this.statuss = res.data.map(sta => {              
               return { ... sta, value: sta.id_status, status: sta.status }
            })
          })
        },

postRecibos() {
    this.progressValue = 0;
    this.isLoadingRecibos = true;
    
    let corpo = {
        "empresa_id": this.value_empresa.length > 0 ? `${[this.value_empresa.map(e => e.id_empresa)]}` : `${[this.user.id_empresa]}`,
        "tipoFolha": 2,
        "funcionario_id": `${this.user.id_funcionario}`,
        "psg": `${this.user.psg}`,
        "sistema": 1,
        "recibos": []
    };

    // Preenchendo o array de recibos
    this.planilhaDadosRecibos.forEach(recibo => {
        console.log('barra' + this.progressValue);
        
        corpo.recibos.push({
            "registro": recibo['COD'] ? String(recibo['COD']).trim() :  null,  // Converte para string e remove espaços em branco
            "competencia": recibo['REF'] ? moment(recibo['REF'], 'MM/YYYY').format('YYYY-MM-DD') : null,
            "evento_id": recibo['EV'] ? String(recibo['EV']).trim() : null,  // Converte para string e remove espaços em branco
            "valor": String(recibo['PROVENTO']).trim() !='' ? recibo['PROVENTO'] : String(recibo['DESCONTO']).trim() !='' ? recibo['DESCONTO'] :  null,  // Converte para string e remove espaços em branco
            "referencia": String(recibo['HORAS'] || '').trim() !='' ? recibo['HORAS'] :null  // Converte para string e remove espaços em branco            
        });
    });
    
    const url = `${baseApiUrl}/folha/importacao/recibo`;
    axios.post(url, corpo)
        .then(() => {
            this.$toasted.global.defaultSuccess();  
            this.isLoadingRecibos = false;
        })
        .catch(showError);  
},

        

        loadPermissao() {
            let params = {    
                "id_grupo": `${this.user.id_grupo}`,                                            
                "id_empresa": `${this.user.id_empresa}`,     
                         "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                
            };

          const url = `${baseApiUrl}/sac/permissao`
          axios.post(url,{params}).then(res => {
            this.permissoes = res.data.map(permissao => {              
               return { ... permissao, id_area: permissao.id_area}
            })
         //   this.loadSacSolicitacoes()
            
          })
        },

        

        gerarPlanilha() {
        // Objeto com os dados para a planilha
        const dados = this.pedidoferias

        // Cria uma nova planilha
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(dados);

        // Adiciona a planilha ao workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Salva o workbook como arquivo
        XLSX.writeFile(workbook, 'pedido_de_ferias.xlsx');
      },




        loadCarregaSac(sacsolicitacao){
            this.sacsolicitacao = { ...sacsolicitacao }
        },
        loadCarregaSacT(sacsolicitacoestratativa){
            this.sacsolicitacoestratativa = { ...sacsolicitacoestratativa }
        },

        postSac() {                        
        let corpo = { 
                "id_funcionario": `${this.user.id_funcionario}`,
                "parecer": `${this.sacsolicitacao.parecer}`,
                "id_solicitacao": `${this.sacsolicitacao.id_solicitacao}`,
                "id_status": `${this.sacsolicitacao.id_status}`,                
                "status": `${[this.statuss.filter(a => a.id_status == this.sacsolicitacao.id_status).map(a => a.status)]}`        };

        const url = `${baseApiUrl}/sac/solicitacoes/save`   

            axios.post(url,corpo).then(() => {
                    this.$toasted.global.defaultSuccess()
                 //   this.loadSacSolicitacoes()
                    //this.reset() limpar os objetos valores
                })
                .catch(showError)
        },




        

        reset() {            
            this.parecer = ''
            this.sacsolicitacao.parecer = ''
        },




        



      limparFiltro(){
        this.search= ""
      },
  
    },  


    created(){
      this.loadPermissao()           
    },



  mounted() {    
        this.loadEmpresas()                                        
        this.loadGaragens()          
        this.loadTipoFolha()     
        //this.loadPermissao()   
      //  this.loadSacSolicitacoes()     
        this.loadCarregaSac() 
        this.loadCarregaSacT()   
        //this.loadSacSolicitacoesTratativas() desabilitei em 20/08/2023 as 20:43h

    },
    

}


</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#selecaostatusx{
    font-size: 0.9em;      
}

#re-nome{
    font-size: 0.9em;      
}

#funcao{
    font-size: 0.9em;      
}

#re-solicitante{
    font-size: 0.9em;      
    font-style: inherit;
    
}


#parecer{
    font-size: 0.9em;      
}


#rfilancamentos{   
    font-size: 0.9em;      
    text-align: center;    
}

#resolicitante{
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
}





</style>